import React from 'react';
import Button from '../ui/Button';
import { getRequestStatusTone } from '../requests/requestUtils';

function renderReasonCell(request) {
  if (String(request.status || '').toLowerCase() === 'denied') {
    return (
      <span className="role-reason-denied">
        {request.reason || 'Denied without a reason provided.'}
      </span>
    );
  }

  return request.reason || 'No reason provided';
}

function OperationalRequestTable({
  emptyMessage = 'No vacation requests found.',
  filteredRequests = [],
  isInitialLoading = false,
  noResultsColSpan = 5,
  selectedRequestId = '',
  showRequesterColumn = false,
  skeletonColumnCount = 5,
  tableClassName = '',
  onSelectRequest = () => {}
}) {
  return (
    <div className="table-card">
      <table className={`role-table ${tableClassName}`.trim()}>
        <thead>
          <tr>
            {showRequesterColumn ? <th className="airport-requests-col-manager">Manager</th> : null}
            <th className={showRequesterColumn ? 'airport-requests-col-dates' : 'ops-requests-col-dates'}>Dates</th>
            <th className={showRequesterColumn ? 'airport-requests-col-time-block' : 'ops-requests-col-time-block'}>Time Block</th>
            <th className={showRequesterColumn ? 'airport-requests-col-status' : 'ops-requests-col-status'}>Status</th>
            <th>Reason</th>
            <th className={showRequesterColumn ? 'airport-requests-col-history' : 'ops-requests-col-history'}>History</th>
          </tr>
        </thead>
        <tbody>
          {filteredRequests.map((request) => {
            const isReturned = String(request.status || '').toLowerCase() === 'returned';
            const isSelected = String(selectedRequestId) === String(request.id);

            return (
              <tr
                key={request.id}
                className={[
                  isSelected ? 'role-request-selected' : '',
                  isReturned ? 'role-request-returned' : ''
                ].filter(Boolean).join(' ')}
              >
                {showRequesterColumn ? (
                  <td className="airport-requests-col-manager">
                    {request.managerName}
                    {isReturned ? <span className="role-returned-badge">Action needed</span> : null}
                  </td>
                ) : null}
                <td className={showRequesterColumn ? 'airport-requests-col-dates' : 'ops-requests-col-dates'}>
                  {request.startDate} to {request.endDate}
                  {!showRequesterColumn && isReturned ? <span className="role-returned-badge">Action needed</span> : null}
                </td>
                <td className={showRequesterColumn ? 'airport-requests-col-time-block' : 'ops-requests-col-time-block'}>
                  {request.timeBlock}
                </td>
                <td className={showRequesterColumn ? 'airport-requests-col-status' : 'ops-requests-col-status'}>
                  <span className={`role-status-pill ${getRequestStatusTone(request.status)}`}>
                    {request.status}
                  </span>
                </td>
                <td>{renderReasonCell(request)}</td>
                <td className={showRequesterColumn ? 'airport-requests-col-history' : 'ops-requests-col-history'}>
                  <Button
                    variant="secondary"
                    onClick={() => onSelectRequest(String(request.id))}
                  >
                    {String(selectedRequestId) === String(request.id) ? 'Viewing' : 'View History'}
                  </Button>
                </td>
              </tr>
            );
          })}
          {filteredRequests.length === 0 && isInitialLoading ? (
            [1, 2, 3].map((rowNumber) => (
              <tr key={`skel-${rowNumber}`} className="role-table-skeleton-row">
                {Array.from({ length: skeletonColumnCount }).map((_, index) => (
                  <td key={index}><span className="role-skeleton-cell" /></td>
                ))}
              </tr>
            ))
          ) : null}
          {filteredRequests.length === 0 && !isInitialLoading ? (
            <tr>
              <td colSpan={noResultsColSpan}>{emptyMessage}</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}

export default OperationalRequestTable;
